import { GzRmTopVulnerabilitiesImpactWidgetWebComponent } from './component/GzRmTopVulnerabilitiesImpactWidgetWebComponent';

export { GzRmTopVulnerabilitiesImpactWidgetWebComponent };
